import { ProductGtmEvents } from '@/gtm/product/product-gtm-events';

export class ProductCardCtaGtmEvents extends ProductGtmEvents {
  addToFavorite(productId, productCode) {
    return this.gtmEvent({
      eventAction: 'Карточка_Хедер_ДобавитьВИзбранное',
      eventLabel: JSON.stringify({
        product_id: productId,
        id: productCode,
      }),
    });
  }

  selectSize(productId, productCode) {
    return this.gtmEvent({
      eventAction: 'Карточка_Хедер_ВыбратьРазмер',
      eventLabel: JSON.stringify({
        product_id: productId,
        id: productCode,
      }),
    });
  }

  addToCart(productId, productCode) {
    return this.gtmEvent({
      eventAction: 'Карточка_Хедер_ДобавитьВКорзину',
      eventLabel: JSON.stringify({
        product_id: productId,
        id: productCode,
      }),
    });
  }

  goToCart(productId, productCode) {
    return this.gtmEvent({
      eventAction: 'Карточка_Хедер_ПерейтиВКорзину',
      eventLabel: JSON.stringify({
        product_id: productId,
        id: productCode,
      }),
    });
  }
}
